import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { apiClient } from '@/api/axiosClient';
import PageHeader from '@/components/common/PageHeader';
import DataTable from '@/components/common/DataTable';
import type { DataTableColumn } from '@/components/common/DataTable';
import type { CurrentStockRow } from '@/types/reports';
import { withId } from '@/pages/reports/reportHelpers';

export default function ClientPortalInventoryPage() {
  const { t } = useTranslation('clientPortal');

  const { data: rawRows = [], isLoading } = useQuery({
    queryKey: ['client-portal', 'inventory'],
    queryFn: async () => (await apiClient.get<CurrentStockRow[]>('/client-portal/inventory')).data,
  });
  const rows = withId(rawRows, (r) => `${r.materialId}-${r.warehouseId}`);

  const columns: DataTableColumn<CurrentStockRow>[] = [
    { field: 'materialCode', headerName: t('inventoryPage.table.materialCode') },
    { field: 'materialName', headerName: t('inventoryPage.table.materialName') },
    { field: 'warehouseName', headerName: t('inventoryPage.table.warehouseName') },
    { field: 'quantityOnHand', headerName: t('inventoryPage.table.quantityOnHand'), align: 'right' },
    { field: 'quantityAllocated', headerName: t('inventoryPage.table.quantityAllocated'), align: 'right' },
    { field: 'quantityAvailable', headerName: t('inventoryPage.table.quantityAvailable'), align: 'right' },
  ];

  return (
    <>
      <PageHeader title={t('inventoryPage.title')} subtitle={t('inventoryPage.subtitle')} />
      <DataTable
        columns={columns}
        rows={rows}
        loading={isLoading}
        searchable
        exportFileName="inventory"
      />
    </>
  );
}
